// extracted by mini-css-extract-plugin
module.exports = {"filters":"filters_filters__1f7tY","difficulty":"filters_difficulty__PQJa2"};